import { ExperimentsRoute } from '@/features/experiments/navigation/experimentsRoute';
import { ExperimentsScreen } from '@/features/experiments/screens/ExperimentsScreen';
import { NavigationBar } from '@/navigation/components/navbar/NavigationBar';
import { AppStack } from '@/navigation/stacks/appStack';
import { NavBarType } from '@/navigation/types/navbar';
import { useAppTheme } from '@/styles/hooks/useAppTheme';

export const useExperimentsRouting = () => {
  const { colors } = useAppTheme();

  return {
    experimentsScreens: __DEV__
      ? [
          <AppStack.Screen
            key={ExperimentsRoute.Experiments}
            name={ExperimentsRoute.Experiments}
            component={ExperimentsScreen}
            options={{
              header: () => (
                <NavigationBar
                  title="Experiments"
                  type={NavBarType.DEFAULT}
                  centerTitle
                  backgroundColor={colors.primary}
                  iconColor={colors.onPrimary}
                  titleColor={colors.onPrimary}
                />
              ),
              headerShown: true,
              presentation: 'containedModal',
              animation: 'fade'
            }}
          />
        ]
      : []
  };
};
